import { getRandom } from '@/util/util'
import Axios from 'axios'
export const getConfig = (type, arr = []) => {
  const id = getRandom(1, 100000)
  const idx = arr.findIndex(c => c.id === id)
  if (idx !== -1) {
    getConfig(type, arr)
  } else {
    const date = {
      id,
      w: 50,
      h: 50,
      x: 0,
      y: 0,
      type
    }
    if (type === 'text') {
      date.info = {
        text: '请输入文本内容',
        fontStyle: {
          fontSize: '12px',
          fontFamily: '微软雅黑',
          fontWeight: 'normal', // 是否加粗
          fontStyle: 'normal', // 是否斜体
          textDecoration: 'none', // 是否下划线
          // lineHeight: "12px", //选择的行高
          color: '#000', // 选择的颜色
          textAlign: 'center' // 位置排版
        },
        functionParms: []
      }
      date.w = 'auto'
      date.h = 'auto'
    } else if (type === 'icon') {
      date.info = {

      }
    } else if (type === 'weather') {
      date.w = 280
      date.h = 80
      date.info = {

      }
    } else if (type === 'img') {
      date.info = {
        url: '',
        parms: ''
      }
    } else if (type === 'button') {
      date.info = {
        buttonStyle: 'one',
        // 选中的绑定功能
        bindingFunction: '',
        // 选中的尺寸
        size: 'small',
        // 选中的图标
        icon: 1,
        // 按钮文本
        text: ''
      }
    }
    return date
  }
}

export const uploadImg = (file, url) => {
  return new Promise((resolve, reject) => {
    if (!file) return
    const formData = new FormData()
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
    formData.append('accesstoken', token)
    formData.append('file', file)
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    Axios.post(url, formData, config)
      .then(res => {
        const configUrl = `/confiles/${res.data}`
        resolve(configUrl)
      }).catch(err => {
        reject(err)
      })
  })
}
